export const days: String[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const supportedCountryCodes: String[] = ['DE', 'NL', 'AT', 'CH', 'IT'];
